var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD6A231C-4BE6-4F7A-918D-44F546FB5C94") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-843.000000, -1296.000000)",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pen",
    transform: "translate(843.789163, 1296.184874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7291667,3.89097377 L17.953776,2.68784877 C18.2545573,2.38706752 18.410319,2.07554408 18.4210612,1.75327846 C18.4318034,1.43101283 18.3011068,1.13023158 18.0289714,0.85093471 L17.5670573,0.389020647 C17.2949219,0.109723772 16.995931,-0.0191824777 16.6700846,0.00230189732 C16.3442383,0.0237862723 16.0309245,0.181338356 15.7301432,0.474958147 L14.516276,1.68882533 L16.7291667,3.89097377 Z M0.615885417,18.3284738 L3.30143229,17.2972238 L15.6442057,4.96519252 L13.4420573,2.76304408 L1.09928385,15.1058175 L0.0358072917,17.7161691 C-0.0358072917,17.902367 1.86517468e-14,18.0670805 0.143229167,18.2103097 C0.286458333,18.3535389 0.444010417,18.3929269 0.615885417,18.3284738 Z",
    id: "\\uDBC0\\uDE0A-copy"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.8a3e0dc3f60b445db23f3a6d9ba37665.svg";
export { ForwardRef as ReactComponent };